module.exports = __webpack_public_path__ + "static/media/starship-freighter.cad128b0.svg";